export default "__VITE_ASSET__B98I8gKU__"